import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const FEATURES = [
  { icon: '📅', title: 'Rezervă Mese',       desc: 'Rezervă mese la cluburile tale preferate instant',          color: 'si-blue'   },
  { icon: '🏆', title: 'Turnee',       desc: 'Joacă la turnee și urcă în clasamentul oficial',           color: 'si-orange' },
  { icon: '👨‍🏫', title: 'Antrenori Profesioniști', desc: 'Rezervă sesiuni de coaching cu antrenori experimentați',         color: 'si-purple' },
  { icon: '👥', title: 'Comunitate de Jucători',    desc: 'Găsește parteneri de joc în apropiere pentru meciuri',              color: 'si-green'  },
  { icon: '📊', title: 'Clasament Live',     desc: 'Urmărește-ți ratingul și progresul în timp real',     color: 'si-cyan'   },
  { icon: '🏓', title: 'Descoperă Cluburi',    desc: 'Explorează cluburi de tenis de masă din toată România',                  color: 'si-red'    },
];

const Home: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {/* Hero */}
      <section className="hero container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="hero-badge fade-up">🏓 Comunitatea de Tenis de Masă din România</div>
            <h1 className="hero-title fade-up fade-up-1">
              Ridică-ți nivelul<br />
              <span className="hero-gradient">la Tenis de Masă</span>
            </h1> 
            <p className="hero-sub fade-up fade-up-2">
              Rezervă mese, înscrie-te în turnee, găsește parteneri de joc și urmărește clasamentul — totul într-un singur loc.
            </p>
            <div className="d-flex gap-3 justify-content-center flex-wrap fade-up fade-up-3">
              {!isAuthenticated ? (
                <>
                  <Link to="/register" className="btn hero-btn-primary btn-lg">Începe Gratuit</Link>
                  <Link to="/login" className="btn hero-btn-secondary btn-lg">Autentificare</Link>
                </>
              ) : (
                <Link to="/dashboard" className="btn hero-btn-primary btn-lg">Mergi la Panou →</Link>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="container pb-5">
        <div className="row g-4">
          {FEATURES.map((f, i) => (
            <div key={f.title} className="col-md-4 col-sm-6 fade-up" style={{ animationDelay: `${i * 0.06 + 0.2}s` }}>
              <div className="feature-card">
                <div className={`feature-icon ${f.color}`}>{f.icon}</div>
                <div className="feature-title">{f.title}</div>
                <p className="feature-desc">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {!isAuthenticated && (
          <div className="cta-block fade-up">
            <h3>Pregătit să începi?</h3>
            <p>Alătură-te comunității de jucători de tenis de masă din România</p>
            <Link to="/register" className="btn hero-btn-primary btn-lg">Creează Cont Gratuit</Link>
          </div>
        )}
      </section>
    </>
  );
};

export default Home;
